import Swiper, { Navigation, Pagination, Autoplay, A11y } from 'swiper'

Swiper.use([ Navigation, Autoplay, Pagination, A11y ]);

var swiper = new Swiper('.contextual-publications .swiper-container', 
{

    spaceBetween: 30,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,

    },

    a11y: {
        enabled: true,
        prevSlideMessage: 'Diapositive précédente',
        nextSlideMessage: 'Diapositive suivante',
        paginationBulletMessage: 'Aller à la diapositive {{index}}',
        slideLabelMessage: '{{index}} / {{slidesLength}}', // default
    },
    
    watchOverflow: true
});
